import { memo } from 'react';

export interface Wreath_Props {
    color?: string,
}

const Wreath = (props: Wreath_Props) => {
    const color = props.color ? props.color : '#fff';
    return (
        <svg width="34" height="28" viewBox="0 0 34 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.6477 26.168C19.6848 24.7604 23.3148 22.5084 28.2931 26.168C25.1817 29.2645 21.1368 27.857 18.6477 26.168Z" fill={color} />
            <path d="M25.0917 22.9685C24.9608 21.2313 26.2527 17.1888 32.4407 16.7862C32.0966 21.1399 28.0936 22.66 25.0917 22.9685Z" fill={color} />
            <path
                d="M28.1753 16.4705C27.3384 14.9379 26.8481 10.7259 32.3294 7.85565C33.8133 11.9683 30.7876 14.9747 28.1753 16.4705Z"
                fill={color}
            />
            <path
                d="M27.9546 9.71135C26.3326 9.03458 23.2862 6.05343 25.7456 0.419547C29.504 2.70772 29.0459 6.92664 27.9546 9.71135Z"
                fill={color}
            />
            <path d="M15.3524 26.168C14.3153 24.7604 10.6853 22.5084 5.70706 26.168C8.81847 29.2645 12.8633 27.857 15.3524 26.168Z" fill={color} />
            <path d="M8.90833 22.9685C9.03924 21.2313 7.74728 17.1888 1.55927 16.7862C1.90342 21.1399 5.90644 22.66 8.90833 22.9685Z" fill={color} />
            <path d="M5.8247 16.4705C6.6616 14.9379 7.15193 10.7259 1.67056 7.85565C0.186709 11.9683 3.21237 14.9747 5.8247 16.4705Z" fill={color} />
            <path d="M6.04539 9.71135C7.66737 9.03458 10.7138 6.05343 8.25439 0.419547C4.496 2.70772 4.95412 6.92664 6.04539 9.71135Z" fill={color} />
        </svg>
    );
};

export default memo<Wreath_Props>(Wreath);
